import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'ldc_cookies';

const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Slight delay for UX
      const tm = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(tm);
    }
  }, []);

  const accept = (value) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ accepted: value, ts: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 lg:left-6 lg:right-auto lg:bottom-6 lg:max-w-md z-[60]">
      <div className="rounded-2xl border border-white/10 bg-[#0a1420]/95 backdrop-blur-xl p-5 lg:p-6 shadow-2xl">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-[#00e0c7]/10 border border-[#00e0c7]/20 flex items-center justify-center flex-shrink-0">
            <Cookie className="w-4 h-4 text-[#00e0c7]" />
          </div>
          <div className="flex-1">
            <p className="text-white/80 text-[13px] leading-relaxed">
              {t('legal.cookieBannerText')}{' '}
              <Link to="/legal/cookies" className="text-[#00e0c7] hover:underline">
                {t('footer.cookies')}
              </Link>
            </p>
          </div>
          <button
            onClick={() => accept('rejected')}
            className="text-white/30 hover:text-white p-1 flex-shrink-0"
            aria-label="close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex gap-2">
          <button
            onClick={() => accept('rejected')}
            className="flex-1 h-10 rounded-full border border-white/15 text-white/70 hover:bg-white/5 text-[13px] font-medium transition-colors"
          >
            {t('legal.rejectAll')}
          </button>
          <button
            onClick={() => accept('accepted')}
            className="flex-1 h-10 rounded-full bg-[#00e0c7] hover:bg-[#00c4ad] text-[#0d1b2a] font-semibold text-[13px] transition-colors"
          >
            {t('legal.acceptAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
